let inject = [
  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings'
];

class MenuDropdownController{
  constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings) {
    this.$state = $state;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
    $( ".ver-mas-cat" ).css( "display", "none" );
  }
  
  $onInit() {
  
  }
  
}

MenuDropdownController.$inject = inject;

export default MenuDropdownController;




/** WEBPACK FOOTER **
 ** ./www/components/shared/components/menu-dropdown/menu-dropdown.controller.js
 **/